import fp from 'lodash/fp';
import React from 'react';
import { formatCurrency } from '@factorin/util';

import { Portal, TransitionComponent, animation, useMemoDeps } from 'Modules/ui';
import { useStorageItem } from 'Modules/business/data';

import { AmountsDraggablePopup } from './DraggablePopup';


const getCheckedCount = ({ all, include, exclude }, total) =>
    all ? total - exclude.length : include.length;

const getAmounts = (fields, register, supplies, subtract, ids) => fp.pipe(
    fp.toPairs,
    // eslint-disable-next-line
    fp.filter(([_, { registerField }]) => register[registerField]),
    fp.map(([key, { registerField, supplyField = registerField }]) => [
        key,
        formatCurrency(subtract
            ? register[registerField] - fp.sumBy(id => supplies[id][supplyField], ids)
            : fp.sumBy(id => supplies[id][supplyField], ids)),
    ]),
    fp.fromPairs,
)(fields);

const defaultAmountFields = {
    amountWithoutVat: {
        registerField: 'Amount',
    },
    vat: {
        registerField: 'Vat',
    },
    amountWithVat: {
        registerField: 'AmountWithVat',
    },
};

export const AmountSuppliesPopup = ({
    registerId,
    total,
    checkedIds,
    elements,
    buttons,
    amountFields = defaultAmountFields,
}) => {
    const register = useStorageItem('registers', registerId);

    const count = useMemoDeps(getCheckedCount, [checkedIds, total]);
    const amounts = useMemoDeps(register ? getAmounts : fp.stubObject, [
        amountFields,
        register,
        elements,
        checkedIds.all,
        checkedIds.all
            ? checkedIds.exclude
            : checkedIds.include,
    ]);

    return (
        <Portal>
            <TransitionComponent in={count > 0} timeout={animation * 2}>
                {count > 0 ? (
                    <AmountsDraggablePopup
                        amounts={amounts}
                        count={count}
                        buttons={buttons}
                    />
                ) : <span />}
            </TransitionComponent>
        </Portal>
    );
};
